<template>
    <div id="pay" v-wechat-title="this.title">
        <div class="top"><img src="https://reso.dalongyun.com/yun/dalongyun_page/office_website/recharge.png" alt=""></div>
        <div class="pay-content">
            <div class="pay-title">单笔充值满50元成为永久会员</div>
            <div class="pay-main">
                <div class="pay-main-title">充值金额</div>
                <div class="pay-list">
                    <button class="select_button" v-for="(item,key) in data" :key="key" :class="index==key?'select_button-active':''" @click="swicthCard(key)">
                        <img class="select-button-img" :src="item.corner_icon" width="60px" height="60px" v-if="item.corner_icon.length>0">
                        <div class="select-button-recharge-desc">
                            <div class="select-button-recharge-desc-con">
                                <div class="select-button-recharge-desc-num">
                                    <span class="select-button-recharge-desc-num-value">{{ item.bean_num }}</span> 云豆
                                </div>
                                <div class="select-button-recharge-desc-span" style="margin-top:21px;">赠送{{ item.give_growth }}成长值</div>
                                <span style="width:220px;color:#d1d1d1">---------------------------------------</span>
                                <div class="select-button-recharge-desc-gift-desc" style="float:left;width:100%;" v-html="item.give_desc"></div>
                            </div>
                        </div>
                    </button>
                </div>
                <input v-model="moneyInput"  class="select_button other" placeholder="其他金额" style="width: 22%;height: 66px; color: rgb(124, 124, 124);"
                       :class="index == -1?'select_button-active':''"
                       @click="clickInput"
                       @keyup="keyUpInput"
                />
            </div>
            <div class="pay-type">
                <div class="recharge-con-title-paytype">支付方式</div>
            </div>
            <div class="pay-payment">
                <div class="payTypes">
                    <img src="https://reso.dalongyun.com/yun/dalongyun_page/office_website/alipay.png" alt="支付宝" class="pay-btns payType"
                         :class="payType==0?'payType-active':''"
                         @click="swicthPay(0)"
                    />
                    <img src="https://reso.dalongyun.com/yun/dalongyun_page/office_website/wechat.png" alt="微信" class="pay-btns payType"
                         :class="payType==1?'payType-active':''"
                         @click="swicthPay(1)"
                    />
                </div>
            </div>
            <div class="recharge-con-subBtn-div">
                <div class="pay_money">金额 ：<span id="pay-sign">￥</span><span id="pay-num">{{ money }}</span></div><br>
                <button class="btn recharge-sub-btn" style="color:white" @click="pay">确认支付</button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Pay",
        data () {
            return {
                title:'充值',
                index:0,
                data :[],
                payType:0,
                money:0,
                moneyInput:'',
            }
        },
        methods:{
            swicthCard(index){
                this.index = index;
                this.moneyInput = '';
                this.money = this.data[index].bean_num;
            },
            clickInput(){
                this.index = -1;
            },
            keyUpInput(){
                if(this.moneyInput>2000){
                    this.moneyInput = 2000;
                    this.$warning("最多充值2000");
                }
                this.money = this.moneyInput;
            },
            swicthPay(num){
                this.payType = num;
            },
            pay(){
                if(this.$store.getters.getUserInfo.user_name === undefined){
                    let uri = '/pay';
                    this.$store.dispatch('tmpUri',uri);
                    this.$router.push({'path':'/login'});
                    this.$warning('请先登录');
                }else{
                    this.$warning('待开发');
                }
            }
        },
        mounted(){
            this.$store.dispatch('goodList').then(()=>{
                let list = this.$store.getters.getGoodList;
                this.data = list;
                for(let index in list){
                    if(list[index].is_default == 1){
                        this.money = list[index].bean_num;
                        this.index = index;
                    }
                }
                this.$LoadingBar.finish();
            });
        },
    }
</script>

<style scoped>
    #pay{
        width: 100%;
        overflow: hidden;
    }
    .top{
        margin: 10px 0;
    }
    .pay-content{
        width: 100%;
        padding: 0 15%;
    }
    .pay-title{
        font-size: 32px;
    }
    .pay-main-title{
        float: left;
        width: 100%;
        margin: 16px 0;
        text-align: left;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #565656;
    }
    .pay-list{
        width: 100%;
        overflow: hidden;
    }
    .pay-main{
        width: 100%;
        overflow: hidden;
    }
    .select_button {
        float: left;
        position: relative;
        width: 22%;
        height: 166px;
        color: #4e4e4e;
        border: 1px solid #dddddd;
        border-radius: 3px;
        background-color: #ffffff;
        margin:10px 1%;
    }
    .select_button-active{
        border: 1px solid #ffa14e;
        background-color: #fffbf9;
    }
    .select-button-img {
        position: absolute;
        right: -5px;
        top: -5px;
    }
    .select-button-recharge-desc-con {
        padding: 0;
        font-size: 12px;
    }
    .select-button-recharge-desc-num {
        height: 29px;
        font-size: 32px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #323232;
        line-height: 28px;
    }
    .other{
        padding-left: 22px;
        font-size: 20px;
        color: #000;
    }
    .other input::-webkit-input-placeholder{
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
    }
    .pay-type{
        width: 100%;
    }
    .recharge-con-title-paytype {
        text-align: left;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #565656;
    }
    .pay-payment{
        width: 100%;
    }
    .payTypes {
        width: 100%;
        overflow: hidden;
    }
    .pay-btns {
        float: left;
        width: 22%;
        height: 75px;
        border-radius: 3px;
        margin: 12px 5px;
        border: 1px solid #dddddd;
        cursor: pointer;
        background-color: #ffffff;
    }
    .payType-active {
        border: 1px solid #ffa14e;
        background-color: #fffbf9;
    }
    .recharge-con-subBtn-div {
        margin-top: 34px;
        float: left;
    }
    .pay_money {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #565656;
        float: left;
    }
    #pay-sign {
        font-size: 26px;
        font-weight: bolder;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #ff8649;
    }
    #pay-num {
        width: 65px;
        height: 21px;
        font-size: 28px;
        font-weight: bolder;
        font-stretch: normal;
        letter-spacing: 1px;
        color: rgb(255, 134, 73);
    }
    .recharge-sub-btn {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #ffffff;
        width: 161px;
        height: 48px;
        text-align: center;
        padding: 5px 10px;
        background: #ff4f4f;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        margin: 20px 0;
    }
</style>
